import { Button } from '@simplywallst/ui-core/next';

interface Props {
  disabled?: boolean;
  onSave: () => void;
  onDiscard: () => void;
}

export const Footer = ({ disabled = false, onSave, onDiscard }: Props) => {
  return (
    <div className="grid grid-cols-[minmax(auto,_1200px)] justify-center items-center bg-surface-1">
      <div className="grid grid-cols-[max-content_max-content] justify-between items-center px-x2">
        <Button variant="secondary" onClick={onDiscard} isDisabled>
          Discard and go back
        </Button>
        <Button variant="primary" isDisabled={disabled} onClick={onSave}>
          Save
        </Button>
      </div>
    </div>
  );
};
